var exports = {
  "Uw": "orgConflictSubHeader__UQdxvH",
  "ZW": "orgConflictRow__-W43xj",
  "lE": "avatarLabelGroup__gJ8NhQ",
  "jj": "avatarIcon__aylbAs",
  "yG": "orgConflictPropertyTypeLabel__kptFS_",
};

module.exports = exports;
